import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://jkouufahpliqgyvcmbwb.supabase.co';
const supabaseAnonKey = 'sb_publishable_3mx9WR7tJggjnVTX5D6OuA_HQ23bz38';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    autoRefreshToken: true,
    persistSession: true
  }
});
